'use strict';

require('./cn-questionnaire-pager.scss');

module.exports = {
  template: require('./cn-questionnaire-pager.html'),
  controller: require('./cn-questionnaire-pager.controller'),
  controllerAs: 'vm',

  bindings: {
    current: '<',
    max: '<',
    onChange: '&',
    hideCompleted: '<'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/cn-questionnaire-pager/index.js
 ** module id = 110
 ** module chunks = 0
 **/